// src/hooks/useLogAccess.js
import { useState, useCallback } from 'react';
import { useAuth } from './useAuth';
import { LOG_PERMISSIONS } from '../constants/logPermissions';

const useLogAccess = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = useCallback((permission) => {
    if (!user || !user.perfilAdmin) return false;
    return LOG_PERMISSIONS[user.perfilAdmin]?.permissions.includes(permission);
  }, [user]);

  const canViewSensitiveData = useCallback(() => {
    return hasPermission('VIEW_SENSITIVE') || 
           (hasPermission('VIEW_SENSITIVE_INSTITUTION') && user?.instituicaoId);
  }, [hasPermission, user]);

  const canExportLogs = useCallback(() => {
    return hasPermission('EXPORT') || 
           (hasPermission('EXPORT_INSTITUTION') && user?.instituicaoId);
  }, [hasPermission, user]);

  const canDeleteLogs = useCallback(() => {
    return hasPermission('DELETE');
  }, [hasPermission]);

  // Novas funcionalidades adicionadas
  const canAccessInstitutionLogs = useCallback(() => {
    return user?.tipo === 'instituicao' && 
           ['ADMIN_INSTITUICAO', 'AUDITOR_INTERNO'].includes(user?.perfilAdmin);
  }, [user]);

  const getPermittedFilters = useCallback(() => {
    if (user?.perfilAdmin === 'SUPER_ADMIN') {
      return ['data', 'acao', 'entidade', 'status', 'instituicao', 'tipoLog', 'nivelSensibilidade'];
    }
    if (user?.perfilAdmin === 'AUDITOR_INTERNO') {
      return ['data', 'acao', 'entidade', 'status', 'tipoLog'];
    }
    if (user?.perfilAdmin === 'ADMIN_INSTITUICAO') {
      return ['data', 'acao', 'entidade', 'status'];
    }
    return [];
  }, [user]);

  return {
    loading,
    error,
    hasPermission,
    canViewSensitiveData,
    canExportLogs,
    canDeleteLogs,
    isAdmin: user?.perfilAdmin === 'SUPER_ADMIN',
    isAuditor: user?.perfilAdmin === 'AUDITOR_INTERNO',
    // Novas propriedades
    canAccessInstitutionLogs,
    permittedFilters: getPermittedFilters(),
    institutionId: user?.instituicaoId
  };
};

export default useLogAccess;